module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/hairstyle_02@2x-d9e063029128a298f1b4f1ace399c6f9.webp";